import useMultpleTable from '../../../hooks/useMultipleTable';
import { Table } from '../../Table';
import { MultiTableComponentProps } from '../types';

const columnLables = {
  entity_name: {
    name: "Company's name"
  },
  entity_identification_bic: {
    name: "Company's BIC"
  },
  entity_identification_lei: {
    name: "Company's LEI"
  },
  transaction_type: {
    name: 'Transaction type'
  },
  voting_rights_rate: {
    name: '% Voting rights'
  },
  other_transaction_type_description: {
    name: 'Description of other transaction type'
  }
};

export function DominantInfluences({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds,
  onAddColumn,
  onDeleteColumn
}: MultiTableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useMultpleTable({
    data: funds[currentDataKey]?.fund_data?.DOMINANT_INFLUENCES,
    onChangeFund,
    schema: schema.DOMINANT_INFLUENCES,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.DOMINANT_INFLUENCES?.field_names || [],
    tableName: 'DOMINANT_INFLUENCES',
    funds,
    isMultiFunds,
    columnLables,
    order: 177 as any,
    onAddColumn,
    onDeleteColumn
  });

  return (
    <Table
      id="fca-reporttables-dominant-influences-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
      stickyTopRows={isMultiFunds ? 1 : null}
    />
  );
}
